/** "A $68 ticket becomes $54.40" — the discount worked through on the example ticket. */
import {
  formatCampaignDollars,
  TicketSalesCampaignDiscountType,
  type CampaignDiscount,
} from '@bonsai/shared';

import { SAMPLE_WORKSHOP, samplePriceAfter } from './campaign-preview';

import './ticket-sales-campaigns-editor.css';

export interface CampaignDiscountExampleProps {
  discount: CampaignDiscount;
}

export function CampaignDiscountExample({ discount }: CampaignDiscountExampleProps) {
  return (
    <span className="tsc-discount-example">
      A {formatCampaignDollars(SAMPLE_WORKSHOP.priceCents)} ticket becomes{' '}
      <b className="nb-tabular" style={{ color: 'var(--nb-primary-2)' }}>
        {formatCampaignDollars(samplePriceAfter(discount))}
      </b>
      {discount.discountType === TicketSalesCampaignDiscountType.FLAT && ' per ticket'}
    </span>
  );
}
